import { ColorsGridProps } from './Types'
import Styles from './ColorsPanel.module.scss'
import { ColorSwatch } from '../ColorSwatch/ColorSwatch'
import { isEqual } from 'lodash'
import Plus from './Plus'
import { PropsWithChildren } from 'react'

export const ColorsGrid = ({
  colors,
  onSelect,
  selectedColor,
  newButtonColor,
  onNewPress,
  size,
  children,
}: PropsWithChildren<ColorsGridProps>) => (
  <div className={Styles.colorsGrid}>
    {colors.map((color, index) => {
      return (
        <div key={`${JSON.stringify(color)}-${index}`} className={Styles.colorGridItem}>
          <ColorSwatch
            color={color}
            size={size}
            isSelected={isEqual(color, selectedColor)}
            onPress={() => onSelect(color)}
          />
        </div>
      )
    })}
    {onNewPress && (
      <div className={Styles.colorGridItem}>
        <span className={Styles.newColorSwatchWrapper}>
          <ColorSwatch
            size={size}
            color={newButtonColor || { type: 'solidColor', color: 'white', opacity: 1 }}
            onPress={onNewPress}
          >
            <Plus />
          </ColorSwatch>
        </span>
      </div>
    )}
    {children}
  </div>
)
